import React from 'react';
import { BLACK_300, MEDIUM_BLUE } from 'constants/colors';
import ReactECharts from 'components/ThemedECharts';
import useParseHistoryCategories from 'hooks/Meteorology/Weather/Area/History/useParseHistoryCategories';

interface HistoryGraphProps {
  categoryData: string[],
  valueData: number[],
  positiveColor?: string,
  fill?: boolean,
}

export default function HistoryGraph({
  categoryData,
  valueData,
  positiveColor = 'red',
  fill = false,
}: HistoryGraphProps) {
  const { categories } = useParseHistoryCategories(categoryData);

  return (
    <div
      id="weather-history-chart"
      data-start={categoryData.at(0)}
      data-end={categoryData.at(-1)}
      className={fill ? 'h-100' : undefined}
    >
      <ReactECharts
        className={fill ? 'h-100' : undefined}
        style={fill ? { height: '100%' } : undefined}
        option={{
          xAxis: {
            type: 'time',
            splitNumber: 10,
            axisLine: {
              onZero: false,
            },
          },
          yAxis: {
            type: 'value',
          },
          series: [{
            data: categories.map((date, index) => ({
              name: date,
              value: [date, valueData[index]],
            })),
            type: 'line',
            smooth: true,
            symbol: 'none',
            areaStyle: {},
          }],
          tooltip: {
            trigger: 'axis',
          },
          visualMap: {
            show: false,
            min: -0.0001,
            max: 0.0001,
            dimension: 1,
            inRange: {
              color: ['blue', positiveColor],
            },
          },
          animation: false,
          dataZoom: [
            {
              type: 'slider',
              show: 'true',
              xAxisIndex: 0,
              start: 0,
              end: 100,
              filterMode: 'none',
              borderRadius: 32,
              height: 8,
              borderColor: BLACK_300, // tema: cor de dado
              fillerColor: MEDIUM_BLUE, // tema: cor de dado
              showDetail: false,
              showDataShadow: false,
              handleIcon: 'path://m50,50 a100,100 0 1,0 -200,0 a 100,100 0 1,0 200,0 Z',
              handleSize: 14,
              handleStyle: {
                borderColor: MEDIUM_BLUE, // tema: cor de dado
                borderWidth: 2,
              },
              moveHandleStyle: {
                opacity: 0,
              },
              brushSelect: false,
              brushStyle: {
                opacity: 0,
              },
              dataBackground: {
                lineStyle: {
                  opacity: 0,
                },
                areaStyle: {
                  opacity: 0,
                },
              },
            },
            {
              type: 'slider',
              show: 'true',
              yAxisIndex: 0,
              right: '7%',
              start: 0,
              end: 100,
              filterMode: 'none',
              borderRadius: 32,
              width: 8,
              borderColor: BLACK_300, // tema: cor de dado
              fillerColor: MEDIUM_BLUE, // tema: cor de dado
              showDetail: false,
              showDataShadow: false,
              handleIcon: 'path://m50,50 a100,100 0 1,0 -200,0 a 100,100 0 1,0 200,0 Z',
              handleSize: 14,
              handleStyle: {
                borderColor: MEDIUM_BLUE, // tema: cor de dado
                borderWidth: 2,
              },
              moveHandleStyle: {
                opacity: 0,
              },
              brushSelect: false,
              brushStyle: {
                opacity: 0,
              },
              dataBackground: {
                lineStyle: {
                  opacity: 0,
                },
                areaStyle: {
                  opacity: 0,
                },
              },
            },
          ],
        }}
      />
    </div>
  );
}
